<div *ngIf="stepHeader" class="step-header">
  <span class="step-title">{{ stepHeader.title }}</span>
  <span class="step-descriptions">
    <span class="step-description">{{ stepHeader.description }}</span>
  </span>
</div>
